import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 5L6.75 13.25L3 9.5",
		stroke: "#00AE9B",
		strokeWidth: 1.45455,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgCheck as ReactComponent };
